import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import PayoutPageContainerComponent from './PayoutPageContainer/PayoutPageContainer.container';

const PayoutPage = ({ t }) => {
    const staticNames = t?.payoutPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content finance">
                <PayoutPageContainerComponent />
            </section>
        </React.Fragment>
    );
};

PayoutPage.propTypes = {
    t: PropTypes.object
};

export default withTranslation(PayoutPage);
